import React, {useState} from "react";
import {CreateProfile} from "./CreateProfile";
import {isProviderEmailVerified, isProviderMobileNumberVerified} from "../../util/ProviderUtil";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {Email} from "./Email";
import {Mobile} from "./Mobile";

export const ProviderOnboarding = () => {

  const {provider, setProvider} = useProviderProfile()

  const getContent = () => {

    if (!provider?.profile?.agreedToTerms) {
      return <CreateProfile onAdvance={() => {
      }}/>
    }

    if (!isProviderMobileNumberVerified(provider, provider?.mobileNumber)) {
      return <Mobile/>
    }

    // Once all this is set, App.tsx will go away from onboarding.
    return <Email/>
  }

  return <div className={'VerticalScrollingSection'}>
    <div className={'AppSection WhiteSection'}>
      <div className={'AppSectionContent'}>
        <div className='SurveySection'>

          <div className={'SurveyHeader'}>

            {getContent()}

          </div>

        </div>
      </div>
    </div>
  </div>
}